export const Version = {
    version: `v.${Env.config.RELEASE.version}`,
    date: Env.config.RELEASE.date,
    branch: Env.config.RELEASE.branch,
    commit: Env.config.RELEASE.commit,
};
export const printVersion = () => {
    const message = `Hi there 👋
You are using annotely.com
Version: ${Version.version}
Date: ${Version.date}
Branch: ${Version.branch}
Commit: ${Version.commit}
    `;
    // eslint-disable-next-line no-console
    console.log(message);
};
